import {
    MessageTypes,
    InteractiveSubtypes,
    SupportedTypes,
} from "@/components/whatsapp-managment/interfaces.js";
import i18n from "@/locales/index.js";

export const loadFile = (fileName) => {
    return window.location.origin + "/assets/image/" + fileName;
};

export const numberTo2DigitsAfterDecimalPoint = (stringVal) => {
    if (!stringVal) return "-";
    const num = Number(stringVal);
    if (isNaN(num)) return "-";
    return Number(num.toFixed(2));
};

export const fetchAudioMetadata = (url) => {
    return new Promise((resolve, reject) => {
        const audio = new Audio();
        audio.addEventListener("loadedmetadata", () => {
            resolve(Math.floor(audio.duration));
        });

        audio.addEventListener("error", () => {
            reject(0);
        });

        audio.src = url;
    });
};

export const formatTimeDuration = (duration) => {
    const minutes = Math.floor(duration / 60);
    const remainingSeconds = Math.floor(duration % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

export const getMessageType = (message) => {
    if (message?.type == MessageTypes.Text) return SupportedTypes.Text;
    if (message?.type == MessageTypes.Audio) return SupportedTypes.Audio;
    if (message?.type == MessageTypes.Image) return SupportedTypes.Image;
    if (message?.type == MessageTypes.Order) return SupportedTypes.Order;
    if (
        message?.type == MessageTypes.Interactive &&
        message?.content?.interactive?.type ==
            InteractiveSubtypes.PaymentSummary
    )
        return SupportedTypes.PaymentDetails;
    return SupportedTypes.NotSupported;
};

export const makeBold = (text) => {
    const regex = /\*(.*?)\*/g;
    return text.replace(regex, "<strong>$1</strong>").replace(/\n/g, "<br />");
};

export const getInteractiveMessageProps = (message) => {
    let textMessage = "";
    const interactiveType = message?.content?.interactive?.type;
    const pseudoInteractiveType = message?.content?.type;

    if (!interactiveType && !pseudoInteractiveType)
        return { text: "", icon: "bi-bookmark-dash" };

    // When message has message.content.type
    // @TODO Add nfm_reply messages
    if (pseudoInteractiveType) {
        switch (pseudoInteractiveType) {
            case InteractiveSubtypes.ButtonReply:
                textMessage = message?.content?.button_reply?.title;
                return {
                    text: textMessage ?? i18n.global.t("Order Summary Options"),
                    icon: "bi-bookmark-dash",
                };
            case InteractiveSubtypes.nfmReply:
                textMessage = message?.content?.nfm_reply?.body;
                return {
                    text: textMessage ?? i18n.global.t("Order Summary Options"),
                    icon: "bi-bookmark-dash",
                };
            default:
                return {
                    text: "",
                    icon: "bi-bookmark-dash",
                };
        }
    }

    // When message has message.content.interactive.type
    switch (interactiveType) {
        case InteractiveSubtypes.PaymentSummary:
            return {
                text: i18n.global.t("Order Summary"),
                icon: "bi-bookmark-dash",
            };
        case InteractiveSubtypes.Catalog:
            return { text: i18n.global.t("catalog"), icon: "bi-bag" };
        case InteractiveSubtypes.Product:
            return {
                text: i18n.global.t("an product"),
                icon: "bi-cart",
            };
        case InteractiveSubtypes.Products:
            return {
                text: i18n.global.t("Products"),
                icon: "bi-tags me",
            };
        case InteractiveSubtypes.InteractiveButtons:
            textMessage = message?.content?.interactive?.header?.text;
            return {
                text: textMessage ?? i18n.global.t("Order Summary Options"),
                icon: "bi-bookmark-dash",
            };
        case InteractiveSubtypes.Flow:
            textMessage = message?.content?.interactive?.body?.text;
            return {
                text: textMessage ?? i18n.global.t("Address"),
                icon: "bi-bookmark-dash",
            };
        default:
            return {
                text: "",
                icon: "bi-bookmark-dash",
            };
    }
};

export const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    // Extract the components of the date
    const year = date.getUTCFullYear(); // YYYY
    const month = date.getUTCMonth() + 1; // MM (getMonth() returns 0-11, so add 1)
    const day = date.getUTCDate(); // DD
    const hour = date.getUTCHours(); // HH
    const minute = date.getUTCMinutes(); // mm

    // Format the components into a string with leading zeros where necessary
    return `${year}/${month.toString().padStart(2, "0")}/${day
        .toString()
        .padStart(2, "0")} <span> ${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}</span`;
};

export const formatStringWithCommas = (val) => {
    const number = Number(val);
    if (isNaN(number)) {
        return val;
    }
    return new Intl.NumberFormat("en-US").format(number);
};

export const orderFormattedDate = (dateString, withHour = false) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "-";

    const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(withHour && { hour: "numeric", minute: "numeric", hour12: false }),
    };
    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date).reduce((acc, part) => {
        if (part.type !== "literal") {
            acc[part.type] = part.value;
        }
        return acc;
    }, {});

    const formattedString = withHour
        ? `${i18n.global.t(parts.weekday)} ${parts.day} ${i18n.global.t(parts.month)} ${parts.year} ${
              parts.hour
          }:${parts.minute}`
        : `${i18n.global.t(parts.weekday)} ${parts.day} ${i18n.global.t(parts.month)} ${parts.year}`;

    return formattedString;
};

export const statusBadgeClass = (status) => {
    switch (status) {
        case "DONE":
            return "success-badge";
        case "FAILED":
            return "failed-badge";
        case "DONE_WITH_ERRORS":
        case "PENDING":
            return "pending-badge";
        default:
            return ""; // Default case if none of the statuses match
    }
};
